export default __webpack_public_path__ + "static/media/strength.4a23b1fc.png";